import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, fmtEur, fmtDate } from "@/lib/api";

const descargar = async (desde, hasta) => {
  try {
    const r = await api.get("/eco/export", { params: { desde, hasta }, responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data);
    a.download = `economico_${desde}_${hasta}.xlsx`;
    a.click();
  } catch (e) {
    toast.error(errMsg(e));
  }
};

export const ExportGestoria = ({ desde, hasta }) => (
  <button type="button" onClick={() => descargar(desde, hasta)} data-testid="eco-export"
    className="rounded-md border border-emerald-600 px-3 py-1.5 text-xs font-medium text-emerald-700 hover:bg-emerald-50">Excel para la gestoría ({fmtDate(desde)} – {fmtDate(hasta)})</button>
);

export const Facturas = ({ desde, hasta }) => {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/eco/facturas", { params: { desde, hasta, q } }).then((r) => setRows(r.data));
  }, [desde, hasta, q]);
  return (
    <div className="bg-white border border-slate-200 rounded-lg" data-testid="eco-facturas">
      <div className="p-3 border-b"><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por número o nombre…" data-testid="eco-facturas-buscar" className="h-8 w-72 rounded border border-slate-200 px-2 text-sm" /></div>
      <table className="w-full text-sm">
        <thead className="text-[11px] uppercase tracking-wider text-slate-500 bg-slate-50"><tr>{["Número", "Fecha", "A nombre de", "Paciente", "Total", "Estado"].map((h) => <th key={h} className="px-3 py-2 text-left">{h}</th>)}</tr></thead>
        <tbody className="divide-y divide-slate-100">
          {rows?.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-slate-400">No hay facturas en estas fechas.</td></tr>}
          {rows?.map((f) => (
            <tr key={f.id} data-testid={`eco-factura-${f.numero}`}>
              <td className="px-3 py-2 font-[JetBrains_Mono] text-xs"><Link to={`/economico/factura/${f.id}`} className="text-[#1E3A8A] hover:underline">{f.numero}</Link></td>
              <td className="px-3 py-2 text-xs">{fmtDate(f.fecha)}</td>
              <td className="px-3 py-2">{f.cliente_nombre}</td>
              <td className="px-3 py-2 text-xs text-slate-600">{f.paciente}</td>
              <td className={`px-3 py-2 font-[JetBrains_Mono] text-xs ${f.total < 0 ? "text-rose-700" : ""}`}>{fmtEur(f.total)}</td>
              <td className="px-3 py-2 text-xs">{f.estado === "rectificada" ? <span className="text-rose-700">Rectificada por {f.rectificada_por}</span> : f.rectifica ? `Rectifica ${f.rectifica}` : "Emitida"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
